module.exports = __webpack_public_path__ + "static/media/S3N8-4.a047e650.svg";